import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { FaChevronDown } from 'react-icons/fa6';
import { TOOL_GROUPS } from '../../data/tools';

function ToolsSidebar({ variant = 'panel', onNavigate }) {
  const location = useLocation();
  const [expandedGroup, setExpandedGroup] = useState(TOOL_GROUPS[0]?.title || null);

  useEffect(() => {
    if (location.pathname.startsWith('/barcode')) {
      setExpandedGroup('Barcode Generator');
      return;
    }
    if (location.pathname.startsWith('/qr')) {
      setExpandedGroup('QR Generator');
    }
  }, [location.pathname]);

  const content = (
    <Stack spacing={1.5}>
      {TOOL_GROUPS.map((group) => {
        const isExpanded = expandedGroup === group.title;
        return (
          <Accordion
            key={group.title}
            expanded={isExpanded}
            onChange={() =>
              setExpandedGroup((current) => (current === group.title ? null : group.title))
            }
            disableGutters
            elevation={0}
            sx={{
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              '&:before': { display: 'none' },
              background: variant === 'drawer' ? 'transparent' : 'inherit',
            }}
          >
            <AccordionSummary
              expandIcon={<FaChevronDown size={16} />}
              sx={{
                px: 2,
                py: 0.5,
                minHeight: 56,
                '& .MuiAccordionSummary-content': { my: 1 },
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>{group.title}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, pb: 2 }}>
              <List disablePadding>
                {group.items.map((tool) => (
                  <ListItemButton
                    key={tool.id}
                    component={NavLink}
                    to={tool.path}
                    selected={location.pathname === tool.path}
                    onClick={onNavigate}
                    sx={{ borderRadius: 2, mb: 0.75 }}
                  >
                    <ListItemText primary={tool.label} />
                  </ListItemButton>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Stack>
  );

  if (variant === 'drawer') {
    return <Box>{content}</Box>;
  }

  return (
    <Paper sx={{ p: 2, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>{content}</Paper>
  );
}

export default ToolsSidebar;
